import { defineStore } from "pinia";
import {
  api,
  type Result,
  Success,
  watchRequest,
  type QueryParams,
  type ResultOkRef,
} from "../api";
import {
  type RoutePointPayload,
  type RoutePointResponse,
  RoutePointSchema,
} from "../schemas/route";
import { PaginatedSchema, type Paginated } from "../schemas/paginated";
import { markRaw } from "vue";

class RoutePointsApi {
  private readonly url = (route_id: number) => `/routes/${route_id}/points/`;
  private readonly updateUrl = (route_point_id: number) =>
    `/routepoints/${route_point_id}/`;

  getRoutePoints(
    route_id: number,
    filters?: QueryParams,
  ): ResultOkRef<Success<Paginated<RoutePointResponse[]>>> {
    return watchRequest(
      this.url(route_id),
      PaginatedSchema(RoutePointSchema),
      filters,
    );
  }

  updateRoutePoint(
    route_point_id: number,
    payload: RoutePointPayload,
  ): Promise<Result<RoutePointResponse>> {
    return api.patch(this.updateUrl(route_point_id), RoutePointSchema, payload);
  }
}

const store = defineStore("routePoints", () => ({
  api: markRaw(new RoutePointsApi()),
}));

export function useRoutePoints() {
  return store().api;
}
